import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const EMPTY_CHAT_MESSAGES: { [key: string]: any } = {};

const selectChatMessages = (state: RootState) => state.chats.chatMessages;
const selectChatId = (_state: RootState, chatId: string | undefined) => chatId;

export const selectChatMessagesById = createSelector([selectChatMessages, selectChatId], (chatMessages, chatId) => {
    if (!chatId) return EMPTY_CHAT_MESSAGES;
    return chatMessages[chatId] ?? EMPTY_CHAT_MESSAGES;
});

export const selectLastMessageByChatId = createSelector([selectChatMessagesById], (messages) => {
    const messagesArray = Object.values(messages);
    return messagesArray.length > 0 ? messagesArray[messagesArray.length - 1] : null;
});

export const selectIsSendingByChatId = createSelector(
    [selectLastMessageByChatId, selectChatId],
    (lastMessage, chatId) => {
        return !!chatId && !!lastMessage?.isSending;
    },
);

export const selectIsStopableByChatId = createSelector(
    [selectLastMessageByChatId, selectChatId],
    (lastMessage, chatId) => {
        return !!chatId && !!lastMessage?.isStopable;
    },
);
